module.exports = __webpack_public_path__ + "img/15.93aa45f8.jpg";